import axiosInstance from "../../../config/axios";
import { getDeviceHeaders } from "../../../utils/deviceUtils";
// import { getDeviceHeaders } from "../../../utils/deviceHeaders";

export const getBannerListRetailer = async () => {
    const response = await axiosInstance.get('/retailer/getBannerList');
    return response.data;
}
export const hasMultipleStore = async (
    email: string,
    customerId?: string | number | null,
    tradeShow?: number | string | null,
) => {
    let url = `/retailer/hasmultipleStore/?email=${email}`;
    if (customerId !== undefined && customerId !== null && customerId !== '') {
        url += `&customerId=${customerId}`;
    }
    if (tradeShow !== undefined && tradeShow !== null && tradeShow !== '') {
        url += `&tradeShow=${tradeShow}`;
    }
    const response = await axiosInstance.get(url);
    return response.data;
}

export const switchStore = async (retailerId: string) => {
    const response = await axiosInstance.put(`/retailer/switchStore/${retailerId}`, {}, {
        headers: getDeviceHeaders()
    });
    return response.data;
}

export const getPriceBook = async () => {
    const response = await axiosInstance.get('/retailer/getPriceBook');
    return response.data;
}

export const getAllowedShowBalance = async () => {
    const response = await axiosInstance.get('/retailer/getAllowedShowBalance');
    return response.data;
}